// Начальное состояние записей на групповые занятия
export const BOOKING_INITIAL = {
    appearance: 'mobile',
    date: '',
    yesterday: '',
    tomorrow: '',
    reserves: []
};
// Начальное состояние формы авторизации
export const AUTH_FORM_INITIAL = {
    email: '',
    password: ''
};
// Начальное состояние формы регистрации
export const REGISTRATION_FORM_INITIAL = {
    open: false,
    name: '',
    phone: '',
    email: '',
    birthday: '',
    gender: '',
    password: ''
};
// Начальное состояние формы восстановления пароля
export const RECOVERY_PASSWORD_FORM_INITIAL = {
    open: false,
    email: ''
};
// Начальное состояние формы проверки почты
export const CHECK_EMAIL_FORM_INITIAL = {
    open: false,
    code: '',
    email: ''
};
// Начальное состояние фильтров
export const FILTERS_INITIAL = {
    open: false,
    coaches: [{ id: '', name: '' }],
    types: [{ id: '', name: '' }]
};
// Начальное состояние пользователя
export const USER_INITIAL = {
    id: '',
    name: '',
    hash: ''
};
// Начальное состояние расписания
export const SCHEDULE_INITIAL = {
    open: false,
    services: [],
    masters: [],
    date: '',
    times: [],
    stage: '',
    selected_services: [],
    selected_master: 0,
    selected_time: '',
    max_service_duration_by_master: {},
    all_master_services: {}
};
// Список записей на услуги
export const MY_RESERVES_INITIAL = {
    open: false,
    reserves: []
};
// Начальное состояние формы выбора адреса
export const CHOICE_ADDRESS_FORM_INITIAL = {
    open: false,
    addresses: []
};